import React, { useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import ModalErrorCard from '../db-management/error-card-modal'

type ErrorMessagesAlertProps = {
    title: string
    httpFailure: string
    serverSideErrorMessage: string
    invalidElement: boolean
    onClose: () => void
}

export const ErrorMessagesAlert: React.FC<ErrorMessagesAlertProps> = ({
    title,
    httpFailure,
    serverSideErrorMessage,
    invalidElement,
    onClose
}: ErrorMessagesAlertProps) => {
    const [show, setShow] = useState(false)
    const handleShow = (): void => setShow(true)
    const handleClose = (): void => setShow(false)

    return (
        <ExpandWidth className="form-area">
            <p>
                <div className="error-alert-body">
                    <div className="error-alert-icon">
                        <i className="far fa-times-hexagon" />
                    </div>
                    <div className="error-alert-text">
                        {
                            <ModalErrorCard
                                onHide={handleClose}
                                show={show}
                                passServerSideErrorMessage={serverSideErrorMessage}
                                passHttpFailure={httpFailure}
                            />
                        }
                        {title && title + '.  '}
                        {serverSideErrorMessage && (
                            <>
                                {' '}
                                <a className="error-alert-details" onClick={handleShow}>
                                    {i18n('See error details')}
                                </a>{' '}
                                <span>{i18n('or')}</span>{' '}
                            </>
                        )}
                        <a className="error-alert-dismiss" onClick={onClose}>
                            {i18n('Dismiss') + '.'}
                        </a>
                        {invalidElement && (
                            <>
                                <br />
                                <span>
                                    {i18n(
                                        'MongoDB seems not available at the moment, please check the integration configuration.'
                                    )}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </p>
        </ExpandWidth>
    )
}

const ExpandWidth = styled.div`
    width: 100% !important;

    > div.alert.alert-danger {
        z-index: auto;
        margin: 0;

        > p {
            position: relative;
            > a.btn-alert-close {
                position: absolute;
                right: 7.5px;
                font-size: 16px;
                color: var(--red-700);
            }

            span {
                display: inline-block;
                margin-right: 10px;
            }

            > div.body-alert {
                height: 30px;
                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }
        }
    }
`
